import moment from 'moment';

export const getMonthRange = (date: moment.MomentInput = new Date()) => {
  const start = moment(date).startOf('month').valueOf();
  const end = moment(date).endOf('month').valueOf();
  return { start, end };
};
